var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "webhook_info" },
    [
      _c("b-overlay", { attrs: { show: _vm.is_load, rounded: "sm" } }, [
        _c(
          "button",
          {
            staticClass: "btn btn-lg waves-effect waves-themed w-100 mb-3",
            class: _vm.cur_class,
            attrs: { type: "button" },
            on: { click: _vm.make_action },
          },
          [
            _c("span", { staticClass: "fal fa-check mr-1" }),
            _vm._v(
              "\n            " + _vm._s(_vm.__t(_vm.butt_title)) + "\n        "
            ),
          ]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }